// src/pages/Dashboard/components/Dialogs/JurisprudenceDetailsDialog.js

import React from 'react';

/**
 * Dialog para exibir detalhes de uma jurisprudência
 * @param {boolean} isOpen - Se o dialog está aberto
 * @param {object} jurisprudencia - Objeto da jurisprudência
 * @param {function} onClose - Callback ao fechar
 */
const JurisprudenceDetailsDialog = ({ isOpen, jurisprudencia, onClose }) => {
  if (!isOpen || !jurisprudencia) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="dialog-overlay-dashboard" onClick={handleOverlayClick}>
      <div className="dialog-content-dashboard dialog-large" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header-dashboard">
          <h3>Detalhes da Jurisprudência</h3>
          <button className="dialog-close-dashboard" onClick={onClose}>×</button>
        </div>
        
        <div className="dialog-body-dashboard">
          <div className="jurisprudencia-detalhes">
            <div className="detalhe-row">
              <label>Processo:</label>
              <span>{jurisprudencia.processo_numero || 'N/A'}</span>
            </div>
            
            <div className="detalhe-row">
              <label>Tribunal:</label>
              <span className={`tribunal-badge ${jurisprudencia.tribunal_origem?.toLowerCase()}`}>
                {jurisprudencia.tribunal_origem || 'N/A'}
              </span>
            </div>
            
            <div className="detalhe-row">
              <label>Data do Acórdão:</label>
              <span>
                {jurisprudencia.data_acordao ? 
                  new Date(jurisprudencia.data_acordao).toLocaleDateString('pt-PT') : 
                  'N/A'
                }
              </span>
            </div>
            
            <div className="detalhe-row">
              <label>Meio Processual:</label>
              <span>{jurisprudencia.meio_processual || 'N/A'}</span>
            </div>
            
            <div className="detalhe-row">
              <label>Relator:</label>
              <span>{jurisprudencia.relator || 'N/A'}</span>
            </div>
            
            <div className="detalhe-row">
              <label>Decisão:</label>
              <span>{jurisprudencia.decisao || 'N/A'}</span>
            </div>
            
            {jurisprudencia.tags && jurisprudencia.tags.length > 0 && (
              <div className="detalhe-row">
                <label>Tags:</label>
                <div className="tags-container">
                  {jurisprudencia.tags.map((tag, idx) => (
                    <span key={idx} className="tag-badge">{tag}</span>
                  ))}
                </div>
              </div>
            )}
            
            {jurisprudencia.sumario && (
              <div className="detalhe-row">
                <label>Sumário:</label>
                <div className="sumario-content">
                  {jurisprudencia.sumario}
                </div>
              </div>
            )}
            
            {jurisprudencia.url_original && (
              <div className="detalhe-row">
                <label>URL Original:</label>
                <a 
                  href={jurisprudencia.url_original} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="url-link"
                >
                  Abrir no tribunal
                </a>
              </div>
            )}
          </div>
        </div>
        
        <div className="dialog-footer-dashboard">
          <button onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
};

export default JurisprudenceDetailsDialog;